// src/components/ui/EmptyState.tsx
import type { ReactNode } from 'react';
import { brand, fonts } from '@/lib/tokens';

type Props = {
  icon: string;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
};

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '56px 24px',
        gap: 6,
      }}
    >
      <span
        className="material-symbols-outlined"
        aria-hidden
        style={{ fontSize: 30, color: brand.muted, marginBottom: 6 }}
      >
        {icon}
      </span>
      <h3
        className="font-serif"
        style={{ fontSize: 18, color: brand.onSurface, margin: 0 }}
      >
        {title}
      </h3>
      {description && (
        <p
          style={{
            fontFamily: fonts.sans,
            fontSize: 13,
            color: brand.onSurfaceVariant,
            maxWidth: 340,
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          {description}
        </p>
      )}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
